module.exports = __webpack_public_path__ + "static/media/cookie.37e9ca75.svg";